<template>
      <div class="aasd3">
            <!-- Header -->
            <div class="header" @click="isExpanded = !isExpanded">
                  <slot name="header"></slot>
                  <div class="header__arrow">
                        <svg
                              class="ico"
                              :class="{ up: isExpanded }"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 284.9 284.9"
                        >
                              <path
                                    d="M282 76.5l-14.2-14.3a9 9 0 0 0-13.1 0L142.5 174.4 30.3 62.2a9 9 0 0 0-13.2 0L3 76.5a9 9 0 0 0 0 13.1l133 133a9 9 0 0 0 13.1 0l133-133a9 9 0 0 0 0-13z"
                              ></path>
                        </svg>
                  </div>
            </div>

            <!-- Body -->
            <div class="body" v-if="isExpanded">
                  <slot name="body"></slot>
            </div>
      </div>
</template>

<script>
export default {
	name: "j-expandable-box",
	data() {
		return {
			isExpanded: this.expand
		}
	},
	props: {
		expand: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";

.aasd3 {
	width: 100%;
}

.header {
	position: relative;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	min-height: 40px;
	cursor: pointer;
}

.header:hover {
	opacity: 0.8;
}

.header__arrow {
	position: absolute;
	right: 0;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 32px;
	height: 100%;
}

.header__arrow .ico {
	width: 14px;
	height: 14px;
	transition: all 160ms ease-out;
	fill: var(--color6);
}

.ico.up {
	transform: rotate(180deg);
}

.body {
	width: 100%;
	animation: fadein 240ms ease-out;
}

/* Animations */
@keyframes fadein {
	0% {
		opacity: 0;
		transform: translateY(-2px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}
</style>
